import axios from 'axios'

const baseUrl = process.env.REACT_APP_BACKEND_URL

const matchRoute = async (routeDetails, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }

    const response = await axios.post(baseUrl + `/api/rail/matchRoute`, routeDetails, config)
    // console.log(response.data)
    
    return response.data
}

const railRouteService = {
    matchRoute
}

export default railRouteService